import { render, staticRenderFns } from "./element-trigger-column.vue?vue&type=template&id=187b6c98&scoped=true"
import script from "./element-trigger-column.vue?vue&type=script&lang=js"
export * from "./element-trigger-column.vue?vue&type=script&lang=js"
import style0 from "./element-trigger-column.vue?vue&type=style&index=0&id=187b6c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187b6c98",
  null
  
)

export default component.exports